import(/* webpackMode: "eager" */ "/Users/evelynbardash/projects/accor/payments-checkout/src/app/error.tsx");
